import React from "react";
import { motion } from "framer-motion";
import {
  FaTrain,
  FaShieldAlt,
  FaBolt,
  FaIndustry,
  FaCheckCircle,
} from "react-icons/fa";
import "./Clients.css";

// ASSETS
import finalBanner from "../assets/finalbanner.png";
import c1 from "../assets/c1.png";
import c2 from "../assets/c2.png";
import c3 from "../assets/c3.png";
import c4 from "../assets/c4.png";
import c5 from "../assets/c5.png";
import c6 from "../assets/c6.png";
import c7 from "../assets/c7.png";
import c8 from "../assets/c8.png";
import c9 from "../assets/c9.png";
import c10 from "../assets/c10.png";

const Clients = () => {
  const clientLogos = [
    { name: "Indian Railways", img: c1, type: "Government" },
    { name: "ICF Chennai", img: c2, type: "Coach Factory" },
    { name: "Siemens", img: c3, type: "Global" },
    { name: "ABB", img: c4, type: "Energy" },
    { name: "DMW Patiala", img: c5, type: "Locomotive" },
    { name: "BHEL", img: c6, type: "Power" },
    { name: "Wheel Factory", img: c7, type: "Industrial" },
    { name: "NTPC", img: c8, type: "Energy" },
    { name: "ALSTOM", img: c9, type: "Infrastructure" },
    { name: "PGCIL", img: c10, type: "Grid" },
  ];

  return (
    <div className="clients-page-root">

      {/* ===== HERO ===== */}
    <section
  className="hud-hero"
  style={{
    backgroundImage: `
      linear-gradient(
        to bottom,
        rgba(143, 182, 243, 0.65), /* light blue overlay (top) */
        rgba(214, 230, 250, 0.55), /* soft blue overlay (middle) */
        rgba(255, 255, 255, 0.75)  /* white overlay (bottom) */
      ),
      url(${finalBanner})
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  }}
>
  <div className="hero-content">
   <motion.h1
  className="hero-main-title"
  initial={{ opacity: 0, x: -60 }}
  animate={{ opacity: 1, x: 0 }}
  transition={{ duration: 0.9, ease: "easeOut" }}
>
 OUR CLIENTS
</motion.h1>

  </div>
</section>

      {/* ===== EXACT HEADING SECTION (YOUR IMAGE) ===== */}
      <section className="clients-heading-wrapper">
        <h2 className="clients-heading-title">
          Major <span>Approvals & Customers</span>
        </h2>

        <div className="clients-iso">
          <FaCheckCircle /> ISO 9001:2015 CERTIFIED VENDOR
        </div>
      </section>

      {/* ===== CLIENT GRID ===== */}
      <section className="matrix-section">
        <div className="matrix-grid">
          {clientLogos.map((client, i) => (
            <motion.div
              key={i}
              className="matrix-card"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
            >
              <div className="card-top">
                <span className="category-label">{client.type}</span>
                <span className="status-dot" />
              </div>

              <div className="logo-wrapper">
                <img src={client.img} alt={client.name} />
              </div>

              <h4 className="client-name">{client.name}</h4>
            </motion.div>
          ))}
        </div>
      </section>

      {/* ===== SECTOR STRIP ===== */}
      <section className="sector-strip">
        <div className="strip-grid">
          <div className="strip-item">
            <FaTrain className="strip-icon" />
            <div>
              <h3>RAILWAY</h3>
              <p>Locomotive & Coach</p>
            </div>
          </div>

          <div className="strip-item highlighted">
            <FaShieldAlt className="strip-icon" />
            <div>
              <h3>DEFENSE</h3>
              <p>Naval Shock Proof</p>
            </div>
          </div>

          <div className="strip-item">
            <FaBolt className="strip-icon" />
            <div>
              <h3>POWER</h3>
              <p>765KV Distribution</p>
            </div>
          </div>

          <div className="strip-item">
            <FaIndustry className="strip-icon" />
            <div>
              <h3>GLOBAL</h3>
              <p>Industrial Export</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Clients;
